interface INoItem {
  title?: string;
  desc?: string;
}

const NoItem = ({ title, desc }: INoItem) => {
  return (
    <div className="w-full min-h-[500px] bg-surface/50 py-[50px] flex items-start justify-center rounded-xl border border-dashed border-edge">
      <div className="my-10 text-center animate-fade-in">
        <h2 className="text-heading-color text-md font-heading-font my-1">
          {title ? title : "Chase List Empty 🎉"}
        </h2>
        <p className="text-light-gray text-[.9rem] font-[600]">
          {desc ? desc : "There is nothing to chase 🥳"}
        </p>
      </div>
    </div>
  );
};

export default NoItem;
